import { PlusIcon } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import { Link } from "@/components/ui/link";
import type { Instrument } from "../../types";
import { usePersistedAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TableFilterRow } from "../TableFilterRow";

export function InstrumentsTable({
  instruments,
}: {
  instruments: Instrument[] | undefined;
}) {
  const { options, filterTextProps } = usePersistedAdminGridOptions(
    "instruments",
    instruments,
    [
      {
        field: "model",
        headerName: "Model",
        cellRenderer: (params) => (
          <Link
            href={{
              to: "/admin/instruments/$id/edit",
              params: { id: params.id as string },
            }}
          >
            {params.model}
          </Link>
        ),
        cellRendererParams: (params) => ({
          model: params.data.model,
          id: params.data.id,
        }),
      },
      {
        field: "manufacturer",
        headerName: "Manufacturer",
        filter: "agSetColumnFilter",
      },
      {
        field: "ref",
        headerName: "Integration ID",
      },
    ],
  );

  return (
    <>
      <TableFilterRow inputProps={filterTextProps}>
        <Link
          href={{ to: "/admin/instruments/new" }}
          className={buttonVariants()}
        >
          <PlusIcon data-slot="icon" />
          Add instrument
        </Link>
      </TableFilterRow>
      <AdminGrid {...options} />
    </>
  );
}
